import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export type ConfirmSubscriptionPayloadType = {
  session_id: string;
};

export const confirmSubscriptionApi = (
  data: ConfirmSubscriptionPayloadType
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = '/billing/checkout_session/subscription/confirm/';

  return authApiService.POST(uri, data);
};
